import { FormProvider, useForm } from 'react-hook-form';
import { useAppContext } from 'src/contexts/AppContext';
import { getInHandDateBasedOnEvent } from 'src/utils/eventWithDataUtils';
import { DeliveryType } from 'src/WebApiController';

import {
  SeatSaverListingDetailsInputForm,
  SeatSaverListingWizardProps,
} from './SeatSaverListingWizard.types';
import { SeatSaverListingWizardBody } from './SeatSaverListingWizardBody';

export const SeatSaverListingWizard = ({
  cancelTo,
  events,
  ...rest
}: SeatSaverListingWizardProps) => {
  const { loginContext } = useAppContext();

  const defaultDaysBeforeEvent =
    loginContext?.user?.activeAccount?.sellerAccountSettings
      ?.inHandDaysBeforeEvent ?? 2;

  const methods = useForm<SeatSaverListingDetailsInputForm>({
    defaultValues: {
      inputs:
        events?.map((ev) => ({
          event: ev,
          autoBroadcastCreatedListing: false,
          seatings: [],
          quantity: 0,
          unitNetProceeds: 0,
          websitePrice: 0,
          faceValue: null,
          deliveryType: DeliveryType.InApp,
          inHandDate: getInHandDateBasedOnEvent(ev, defaultDaysBeforeEvent),
          daysBeforeEvent: defaultDaysBeforeEvent,
          sellerOwnTickets: true,
        })) ?? [],
    },
  });

  return (
    <FormProvider {...methods}>
      <SeatSaverListingWizardBody
        {...methods}
        events={events}
        cancelTo={cancelTo}
        {...rest}
      />
    </FormProvider>
  );
};
